import React from 'react'
import { Text, TEXT_VARIANT_LIGHT } from 'mailup-web-components'
import styled from '@emotion/styled'

const NoItems = ({ children }) => {
  return (
    <StyledBox>
      <Text variant={TEXT_VARIANT_LIGHT}>{children}</Text>
    </StyledBox>
  )
}

export default NoItems

const StyledBox = styled.div`
  background-color: #eee;
  border: 1px dashed var(--geyser);
  text-align: center;
  padding: 15px 0;
`
